<template>
  <div>
    <div>
      <link-prevue :url="preview_url" v-if="isURL">
        <template slot-scope="props">
          <div
            class="card d-flex pa-2"
            @click="goToURL()"
            v-if="props.description"
          >
            <img class="card-img-top" :src="props.img" :alt="props.title" />
            <div class="card-block d-flex flex-column px-2">
              <h4 class="card-title">{{ props.title | capitalising }}</h4>
              <p class="text-left">
                {{ props.description }}
              </p>
            </div>
          </div>
          <div v-else>
            <div class="card d-flex pa-2" @click="goToURL(previewData.url)">
              <img
                class="card-img-top pa-1"
                :src="previewData.img"
                :alt="previewData.title.slice(0, 12) | capitalizeFirstLetter"
              />
              <div class="card-block d-flex flex-column px-2">
                <h4 class="card-title">
                  {{ this.previewData.title | capitalizeFirstLetter }}
                </h4>
                <p class="text-left">
                  {{ this.previewData.description }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template slot="loading" class="loader-container">
          <div class="loader-container">
            <div class="card d-flex pa-2" @click="goToURL()">
              <img
                class="card-img-top pa-1"
                :src="previewData.img"
                :alt="previewData.title.slice(0, 12) | capitalising"
              />
              <div
                style="width: 100%"
                class="card-block d-flex flex-column px-2"
              >
                <h4 class="card-title">
                  {{ this.previewData.title | capitalising }}
                </h4>
                <p class="text-left">
                  {{ this.previewData.description }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </link-prevue>
    </div>
  </div>
</template>

<script>
import LinkPrevue from "link-prevue";

export default {
  name: "LinkPreview",
  components: {
    "link-prevue": LinkPrevue,
  },
  props: ["preview_url"],
  data() {
    return {
      previewData: {
        url: "",
        title: "",
        description: " ",
      },
    };
  },
  methods: {
    goToURL() {
      window.open(this.preview_url, "_blank");
    },
    getTitle() {
      if (this.isURL) {
        let domain = new URL(this.preview_url);
        console.log(domain.hostname.replace("www.", ""), "domain");
        return domain.hostname.replace("www.", "");
      } else {
        return null;
      }
    },
    generatePreviewData() {
      this.previewData.description = `See more at ${this.preview_url}`;
      this.previewData.title = this.getTitle();
    },
  },
  mounted() {
    this.generatePreviewData();
  },
  computed: {
    isURL() {
      return this.preview_url;
    },
  },
  filters: {
    capitalising: function (data) {
      let capitalized = [];
      data.split(" ").forEach((word) => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style>
#loader-container {
  width: 100% !important;
}
</style>
<style scoped>
.card {
  border: 0.5px solid grey;
  border-radius: 10px;
  cursor: pointer;
  width: 100%;
}
.loader-container {
  width: 100% !important;
}
.card-img-top {
  object-fit: cover;
  height: 100px;
  background: lightgray;
  width: 100px;
  border-radius: 10px;
}
</style>
